import {
    ADD_ITEM,
    DELETE_CHANGED_ITEMS,
    DELETE_ITEM, SEND_ORDER,
    SET_ALL_ITEM,
    SET_CHANGED_ITEM,
} from "../actions/cart_actions";


const  initialState = {
    cart_items: [],
    chooses_items: [],
};



export function cartReducer(state  = initialState,action) {
    switch (action.type) {
        case SET_CHANGED_ITEM: {
            let changed_array = state.chooses_items;
            if (changed_array.length > 0) {
                if (changed_array.indexOf(action.payload) !== -1) {
                    changed_array.splice(changed_array.indexOf(action.payload), 1);
                } else {
                    changed_array.push(action.payload)
                }
            }
            else
                changed_array.push(action.payload);
            return {...state, chooses_items: changed_array};
        }
        case DELETE_ITEM: {
            let storage = localStorage.getItem('cart');
            if (storage[storage.length-1] === ';') {
                storage = storage.substring(0, storage.length - 1)
            }
            let cart_items = '';
            let cart_array = [];
            if (storage.length > 0) {
                storage = storage.split(';');
                storage.forEach((item, index) => {
                    if (Number(JSON.parse(item).id) !== Number(action.payload)) {
                        cart_array.push(JSON.parse(item));
                        cart_items += storage[index] + ';';
                    }
                });
            }
            let changed_array = state.chooses_items;
            changed_array = changed_array.filter(item => {
                return item !== action.payload
            });
            localStorage.setItem('cart', cart_items);
            return {...state, cart_items: cart_array, chooses_items: changed_array};
        }
        case ADD_ITEM: {
            let cart_array = state.cart_items;
            try {
                let storage_string = localStorage.getItem('cart');
                if (storage_string[storage_string.length - 1] === ';') {
                    storage_string = storage_string.substring(0, storage_string.length - 1)
                }
                let storage = [];
                if (storage_string.length > 0) {
                    try {
                        storage = storage_string.split(';').map(item => {
                            return JSON.parse(item)
                        });
                        cart_array = cart_array.filter(item => {
                            return Number(item.id) !== Number(action.payload.id);
                        });
                        storage = storage.filter(item => {
                            return Number(item.id) !== Number(action.payload.id);
                        });
                    } catch (e) {

                    }
                }
                storage.push(action.payload);
                let result_storage = '';
                storage.forEach(function (item) {
                    result_storage += JSON.stringify(item) + ';'
                });
                cart_array.push(action.payload);
                cart_array.sort((a,b) => {return a.id > b.id?-1:1});
                localStorage.setItem('cart', result_storage);
            }catch (e) {
                localStorage.setItem('cart', '')
            }
            return {...state, cart_items: cart_array};
        }
        case DELETE_CHANGED_ITEMS:{
            let storage = localStorage.getItem('cart').split(';');
            let cart_items = '';
            let change_array = state.chooses_items;
            let cart_array = state.cart_items.filter((item, index) =>{
                if (change_array.indexOf(JSON.parse(storage[index]).id) === -1) {
                    cart_items += storage[index] + ';';
                }
                return change_array.indexOf(item.id) === -1;
            });
            localStorage.setItem('cart', cart_items);
            return {...state, cart_items: cart_array, chooses_items: []};
        }
        case SET_ALL_ITEM: {
            let change_array = state.chooses_items;
            if (action.payload === true) {
                state.cart_items.forEach(function (item) {
                    if (change_array.indexOf(item.id) === -1)
                        change_array.push(item.id)
                });
            }else {
                change_array = [];
            }
            return {...state, chooses_items: change_array};
        }
        case SEND_ORDER:
            return {...state, cart_items: [], chooses_items: [],};
        default:
            return {...state};

    }
}
